import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './stores';
import { globalVar } from './globalVar';
import './assets/tailwind.css';
import 'animate.css';
import './assets/css/animate.css';

// PrimeVue
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import 'primeicons/primeicons.css'
import { ConfirmationService, ToastService } from 'primevue';
import Tooltip from 'primevue/tooltip';
import { definePreset } from '@primevue/themes';

const app = createApp(App);
app.config.globalProperties.$globalVar = globalVar;
app.directive('tooltip', Tooltip);
app.use(store);
app.use(router);
app.use(ConfirmationService);
app.use(ToastService);

// Initialize dark mode on app start
store.dispatch('darkMode/initDarkMode');

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: '{blue.50}',
            100: '{blue.100}',
            200: '{blue.200}',
            300: '{blue.300}',
            400: '{blue.400}',
            500: '{blue.500}',
            600: '{blue.600}',
            700: '{blue.700}',
            800: '{blue.800}',
            900: '{blue.900}',
            950: '{blue.950}'
        }
    }
});


app.use(PrimeVue, {
    theme: {
        preset: MyPreset,
        options: {
            prefix: 'p',
            darkModeSelector: '.dark',
            cssLayer: false
        }
    }
});
app.mount('#app');